<div
  (click)="onTaskItemClick()"
  attr.class="home-task-container {{ taskItem.state }}"
>
  <app-icon class="task-item-state-icon" [icon]="taskItemStateIcon"> </app-icon>

  <p class="task-item-title">{{ taskItem.content.title }}</p>

  <app-icon
    class="task-item-dismiss-icon"
    [icon]="closeIcon"
    (click)="onTaskItemDismiss()"
  ></app-icon>
</div>
